export type CsvCell = string | number | null | undefined

export function serializeCsv(rows: CsvCell[][]): string {
  return rows
    .map((row) =>
      row
        .map((cell) => {
          if (cell == null) return ''
          const str = String(cell)
          if (str.includes(',') || str.includes('"') || str.includes('\n') || str.includes('\r')) {
            return `"${str.replace(/"/g, '""')}"`
          }
          return str
        })
        .join(',')
    )
    .join('\n')
}

export function downloadFile(filename: string, content: string | Blob, mime = 'text/csv;charset=utf-8;') {
  const blob = typeof content === 'string' ? new Blob([content], { type: mime }) : content
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}

export function downloadCsv(filename: string, rows: CsvCell[][]) {
  downloadFile(filename, serializeCsv(rows), 'text/csv;charset=utf-8;')
}

export function downloadJson(filename: string, data: unknown) {
  downloadFile(filename, JSON.stringify(data, null, 2), 'application/json;charset=utf-8;')
}

export function reportFilename(prefix: string, scope: string, asOf: string, ext: string): string {
  const safeScope = scope.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')
  const safeAsOf = asOf.replace(/[^A-Za-z0-9]/g, '')
  return `${prefix}-${safeScope}-${safeAsOf}.${ext}`
}
